import example1 from "./example1";
import subcontainers from "./subcontainers";
import simpleCreate from "./simpleCreate";
import dataSection from "./dataSection";

const bytecodes = { example1, subcontainers, simpleCreate, dataSection };
export default bytecodes;
